import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { State } from '@app/store/state/state';
import { UiUpsellState } from '@upsell/store/state/upsell-module.state';
import { UpsellResponse } from '@shared/flight-itinerary/entities/upsell-flights';
import { getUIUpsellState } from '@upsell/store/selectors/ui.selector';
import { upsellRootSelector } from '@upsell/store/selectors/upsell-root.selector';
import {
  fetchFlightsOptionForPackageUpsellAction,
  fetchFlightsOptionForPackageUpsellForDesktopAction,
  fetchOptionForUpsellAction, fetchPackageUpsellOptionsAction,
  fetchUpsellOptionsAction, fetchUpsellOptionsBySectorAction, resetUpsellAction
} from '@upsell/store/actions/upsell.actions';
import { FetchFlightsOptionPayload } from '@flight-results/entities/fetch-flights-option.payload';
import { UpsellPayload } from '@upsell/entities/upsell-payload';
import { UpsellPackagePayload } from '@packages/packages-result/entities/upsell';

@Injectable({ providedIn: 'root' })
export class UpsellFacade {

  constructor(protected store: Store<State>) { }

  public isLoadingUpsell$: Observable<boolean> = this.store
    .pipe(select(getUIUpsellState), map((state: UiUpsellState) => state.isLoadingUpsell));

  public isLoadingUpsellForDesktop$: Observable<boolean> = this.store
    .pipe(select(getUIUpsellState), map((state: UiUpsellState) => state.isLoadingUpsellForDesktop));

  public upsell$: Observable<UpsellResponse> = this.store
    .pipe(select(upsellRootSelector), map(state => state.upsell));

  public clicked$: Observable<number> = this.store
    .pipe(select(upsellRootSelector), map(state => state.clickedUpsell));

  public searchPayload$: Observable<UpsellPayload> = this.store
    .pipe(select(upsellRootSelector), map(state => state.upsellPayload));

  public upsellForDesktop$: Observable<UpsellResponse> = this.store
    .pipe(select(upsellRootSelector), map(state => state.upsellForDesktop));

  public fetchOptionForUpsellAction(payload: FetchFlightsOptionPayload, isFlightUpsellTreatment?: boolean): void {
    this.store.dispatch(fetchOptionForUpsellAction({
      payload, isFlightUpsellTreatment
    }));
  }

  public fetchUpsellOptionsFlights(
    optionId: number, searchId: string, sessionToken: string, isFlightUpsellTreatment?: boolean): void {
    this.store.dispatch(fetchUpsellOptionsAction({
      optionId: optionId,
      searchId: searchId,
      sessionToken: sessionToken,
      isFlightUpsellTreatment
    }));
  }

  public fetchUpsellOptionsFlightsBySector(
    optionId: number, searchId: string, sessionToken: string, previousOptions: number[]
  ): void {
    this.store.dispatch(fetchUpsellOptionsBySectorAction({
      optionId: optionId,
      searchId: searchId,
      sessionToken: sessionToken,
      previousOptions: previousOptions
    }));
  }

  public resetUpsellAction(): void {
    this.store.dispatch(resetUpsellAction());
  }

  public fetchPackageUpsellOptions(payload: UpsellPackagePayload): void {
    this.store.dispatch(fetchPackageUpsellOptionsAction({ payload }));
  }

  public fetchPackageUpsellAir(payload: FetchFlightsOptionPayload, upsell: UpsellPackagePayload): void {
    this.store.dispatch(fetchFlightsOptionForPackageUpsellAction({ payload, upsell }));
  }

  public fetchPackageUpsellAirDesktop(payload: FetchFlightsOptionPayload, upsell: UpsellPackagePayload): void {
    this.store.dispatch(fetchFlightsOptionForPackageUpsellForDesktopAction({ payload, upsell }));
  }

}
